// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"392e54b0","955":"1ef01e63"}[chunkId] + ".chunk.css";
};